module.exports = __webpack_public_path__ + "static/img/charger-color.2bd81e26.png";